import React from "react";
import { Box } from "@chakra-ui/react";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Section Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box p={4} bg="red.50" color="red.600" borderRadius="md">
          Something went wrong rendering this section. Please try refreshing the
          page.
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
